import { useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { EventFormTemplate } from '../../../types/EventFormTemplate';

export const fetchEventFormTemplate = async (uuid?: string, submission_uuid?: string) => {
  if (uuid === undefined && submission_uuid === undefined) return null;

  const response = await CustomAxios.get<EventFormTemplate>(`form_submissions/event_form_template/${uuid || submission_uuid}`);
  const { data } = response;
  return data;
};

interface UseGetEventFormTemplateByIdProps {
  uuid?: string;
  submission_uuid?: string;
}

export function useGetEventFormTemplateById({ uuid, submission_uuid }: UseGetEventFormTemplateByIdProps) {
  return useQuery({
    queryKey: [queryKeys.allEventFormTemplates, uuid, submission_uuid],
    queryFn: () => fetchEventFormTemplate(uuid, submission_uuid),
  });
}
